import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { __ } from '@wordpress/i18n';
import { useLocation } from 'react-router-dom';
import { NavActiveSVG, IconMenuNavSVG } from '../icon';
import ReactDOM from 'react-dom';

const Navigation = () => {
    const { root, homeSlug, homeUrl, menus: menu, proActive, imgDir } = window['JkitDashboardOption'];
    const [injectLocation, setInjectLocation] = useState(null);
    const { pathname, search } = useLocation();
    const query = new URLSearchParams(search);
    const subPath = query.get('subpath') ? query.get('subpath') : '';
    const path = query.get('path') ? subPath ? query.get('path') + '&subpath=' + subPath : query.get('path') : '';

    const sortMenu = Object.entries(menu);

    sortMenu.sort((a, b) => a[1].priority - b[1].priority);

    const menus = [];
    sortMenu.forEach(menu => {
        menus.push({
            id: menu[0],
            name: menu[1].name,
            slug: menu[1].type === 'url' ? menu[1].url : root,
            type: menu[1].type,
            priority: menu[1].priority,
            path: menu[0] === 'dashboard' ? '' : menu[1].parent ? menu[1].parent + '&subpath=' + menu[0] : menu[0],
            parent: menu[1].parent ? menu[1].parent : false
        });
    });

    useEffect(() => {
        const submenu = document.querySelector('#toplevel_page_' + root + ' > ul');
        const list = submenu.getElementsByTagName('li');
        Array.from(list).forEach((item) => {
            item.remove();
        });
    }, []);

    setTimeout(() => {
        let injectLocation = document.querySelector('#toplevel_page_' + root + ' .wp-submenu');
        setInjectLocation(injectLocation);
    }, 1);

    const navigationButton = (
        <>
            <li className="wp-submenu-head" aria-hidden="true">
            </li>
            {menus.map((menu) => {
                let param = `?page=${menu.slug}`;

                if ('' !== menu.path) {
                    param += `&path=${menu.path}`;
                }
                return (
                    <li key={menu.path} className={`${menu.path === path ? 'current' : ''} ${menu.parent ? 'jkit-child-menu' : ''}`}>
                        {menu.type === 'url' ?
                                <a className={`f-navigation__item ${menu.path === path ? 'f-navigation__item--active' : ''} ${menu.parent ? 'jkit-child-menu' : ''}`} href={menu.slug}>
                                    {menu.name}
                                </a>
                                :
                                <Link
                                    index={`${menu.path}`}
                                    className={menu.parent ? 'jkit-child-menu' : ''}
                                    to={{
                                        pathname: pathname,
                                        search: param,
                                    }}>
                                    {menu.name}
                                </Link>
                        }
                    </li>
                );
            })}
            {!proActive && path !== '' && (
                <li className={`jkit-upgrade-to-pro-menu ${'' === path ? 'current' : ''}`}>
                    <Link
                        to={{
                            pathname: pathname,
                            search: `?page=${root}&utm_source=jeg-elementor-kit&utm_medium=nav-menu`,
                        }}>
                        {__('Upgrade to Pro', 'jeg-elementor-kit')}<img src={imgDir + 'crown.svg'} alt="" />
                    </Link>
                </li>
            )}
        </>
    );

    const mainMenu = [];
    const subMenu = [];
    menus.map((menu) => {
        if (menu.parent) {
            if (!subMenu[menu.parent]) {
                subMenu[menu.parent] = [];
            }
            subMenu[menu.parent].push(menu);
        } else {
            mainMenu.push(menu);
        }
    });

    return (
        <>
            <div className="f-navigation">
                <div className="f-navigation-wrapper">
                    <div className="f-logo-wrapper">
                        <div className="f-navigation-logo">
                            <img src={`${imgDir}/admin/jegkit-logo-black.png`} />

                        </div>
                    </div>
                    <div className="f-navigation-wrapper-items">
                        <div className="f-navigation__items">
                            {mainMenu.map((menu) => {
                                let param = `?page=${menu.slug}`;

                                if ('' !== menu.path) {
                                    param += `&path=${menu.path}`;
                                }

                                if (menu.pathDetail) {
                                    param += menu.pathDetail;
                                }

                                return (
                                    menu.type === 'url' ? <a className={`f-navigation__item ${path.includes(menu.path) ? 'f-navigation__item--active' : ''}`} href={menu.slug}>
                                        <span><NavActiveSVG />{menu.name}</span>
                                        {subMenu[menu.id] ? <div className="f-submenu__item">{subMenu[menu.id].sort(function (a, b) {
                                            return a.priority - b.priority;
                                        }).map((menu) => {
                                            let param = `?page=${menu.slug}`;

                                            if ('' !== menu.path) {
                                                param += `&path=${menu.path}`;
                                            }

                                            if (menu.pathDetail) {
                                                param += menu.pathDetail;
                                            }

                                            return (
                                                menu.type === 'url' ? <a className={`f-navigation__item f-navigation__subitem ${path.includes(menu.path) ? 'f-navigation__item--active' : ''}`} href={menu.slug}>
                                                    <span><IconMenuNavSVG />{menu.name}</span>
                                                </a> : <Link
                                                    index={menu.path}
                                                    key={menu.path}
                                                    to={{
                                                        pathname: pathname,
                                                        search: param,
                                                    }}
                                                    className={`f-navigation__item f-navigation__subitem ${path.includes(menu.path) ? 'f-sub-navigation__item--active' : ''}`}>
                                                    <span><IconMenuNavSVG />{menu.name}</span>
                                                </Link>
                                            );
                                        })}</div> : ''}
                                    </a> : <Link
                                        index={menu.path}
                                        key={menu.path}
                                        to={{
                                            pathname: pathname,
                                            search: param,
                                        }}
                                        className={`f-navigation__item ${path.includes(menu.path) && menu.path !== '' ? 'f-navigation__item--active' : menu.path === '' && path === menu.path ? 'f-navigation__item--active' : ''}`}>
                                        <span><NavActiveSVG />{menu.name}</span>
                                        {subMenu[menu.id] ? <div className="f-submenu__item">{subMenu[menu.id].sort(function (a, b) {
                                            return a.priority - b.priority;
                                        }).map((menu) => {
                                            let param = `?page=${menu.slug}`;

                                            if ('' !== menu.path) {
                                                param += `&path=${menu.path}`;
                                            }

                                            if (menu.pathDetail) {
                                                param += menu.pathDetail;
                                            }

                                            return (
                                                menu.type === 'url' ? <a className={`f-navigation__item f-navigation__subitem ${menu.path === path ? 'f-navigation__item--active' : ''}`} href={menu.slug}>
                                                    <span><IconMenuNavSVG />{menu.name}</span>
                                                </a> : <Link
                                                    index={menu.path}
                                                    key={menu.path}
                                                    to={{
                                                        pathname: pathname,
                                                        search: param,
                                                    }}
                                                    className={`f-navigation__item f-navigation__subitem ${menu.path === path ? 'f-sub-navigation__item--active' : ''}`}>
                                                    <span><IconMenuNavSVG />{menu.name}</span>
                                                </Link>
                                            );
                                        })}</div> : ''}
                                    </Link>
                                );
                            })}

                            {!proActive && path !== '' && <UpgradeProButton />}
                        </div>
                    </div>
                </div>
            </div>
            {injectLocation && ReactDOM.createPortal(navigationButton, injectLocation)}
        </>
    );
};

const UpgradeProButton = () => {
    const { root, pathname } = { root: window['JkitDashboardOption']?.homeSlug, pathname: window.location.pathname };
    return (
        <span className='navigation__button'>
            <Link className='upgrade-pro-btn' to={{ pathname, search: `?page=${root}&utm_source=jeg-elementor-kit&utm_medium=nav-button` }}>
                <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.6743 3.4957C14.5342 3.37291 14.3607 3.29474 14.1759 3.27119C13.9911 3.24765 13.8035 3.27982 13.6371 3.36357L10.8949 4.73055L8.55621 0.843009C8.47243 0.70391 8.3541 0.588834 8.21273 0.508949C8.07136 0.429065 7.91173 0.387085 7.74935 0.387085C7.58697 0.387085 7.42734 0.429065 7.28597 0.508949C7.1446 0.588834 7.02628 0.70391 6.94249 0.843009L4.60377 4.73055L1.86103 3.36415C1.69481 3.28111 1.50772 3.24913 1.32335 3.27222C1.13898 3.29532 0.965566 3.37246 0.82496 3.49394C0.684353 3.61542 0.582842 3.77579 0.533216 3.95485C0.483591 4.13392 0.488069 4.32366 0.546089 4.50018L2.70941 11.1275C2.74199 11.2274 2.79657 11.3186 2.86912 11.3946C2.94168 11.4705 3.03036 11.5292 3.12862 11.5663C3.22687 11.6034 3.33221 11.6179 3.43684 11.6089C3.54148 11.5998 3.64275 11.5674 3.73318 11.514C3.74721 11.5058 5.19839 10.6773 7.74818 10.6773C10.298 10.6773 11.7491 11.507 11.7603 11.5134C11.8507 11.5675 11.9522 11.6006 12.0571 11.6101C12.1621 11.6196 12.2678 11.6053 12.3665 11.5684C12.4652 11.5314 12.5543 11.4727 12.6272 11.3966C12.7001 11.3205 12.7549 11.2289 12.7875 11.1287L14.9509 4.50486C15.0106 4.32824 15.0161 4.13781 14.9669 3.958C14.9176 3.77819 14.8157 3.61721 14.6743 3.4957ZM11.6965 9.94765C10.916 9.64829 9.57238 9.2741 7.74818 9.2741C5.92398 9.2741 4.58038 9.64946 3.79983 9.94882L2.2212 5.11293L4.35703 6.17529C4.5693 6.28005 4.81311 6.30147 5.04039 6.23534C5.26767 6.16921 5.46193 6.02033 5.58486 5.81805L7.74818 2.22285L9.9115 5.81864C10.0344 6.02092 10.2287 6.16976 10.456 6.23579C10.6833 6.30182 10.9272 6.28023 11.1393 6.17529L13.2746 5.11118L11.6965 9.94765Z" fill="white" />
                </svg>
                Upgrade To Pro
            </Link>
        </span>
    )
}

export default Navigation;
